import React, { FC } from 'react'

import gridTheme from '../../../../utils/gridTheme'
import { useMediaQuery } from '../../../../utils/useMediaQuery'
import { BlogPostsDesktop } from './desktop/BlogPostsDesktop'
import { useParsedEntries } from './hooks'
import { BlogPostsMobile } from './mobile/BlogPostsMobile'

type Props = {
  id?: string
  className?: string
  /** Entries will be passed along as a stringified json array. */
  entries: string
}

export const BlogEntries: FC<Props> = (props) => {
  const parsedEntries = useParsedEntries(props.entries)
  const isAboveMobile = useMediaQuery(`screen and (min-width: ${gridTheme.breakpoints.lg}px)`)

  if (!isAboveMobile) return <BlogPostsMobile {...props} entries={parsedEntries} />

  return <BlogPostsDesktop {...props} entries={parsedEntries} />
}
